import state from '@/stores/homepage/state.js'
import mutations from '@/stores/homepage/mutations.js'
import actions from '@/stores/homepage/actions.js'
import getters from '@/stores/homepage/getters.js'

export default {
  state,
  mutations,
  actions,
  getters
}
